import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { FormSpy, useField, useForm } from "react-final-form";
import { DateInput } from "@vk-hr-tek/ui/input";
import { CALENDAR_MAX_DATE, CALENDAR_MIN_DATE } from "@vk-hr-tek/ui/services";
import { compose, composeWarnings } from "../validation/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function DateInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else DateInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const getIsRenderError = (errorDisabled, validationWithoutTouch, value, touched, error)=>{
    if (!errorDisabled && validationWithoutTouch) return !!value && !!error;
    return touched && !!error;
};
const getIsRenderWarnings = (errorDisabled, validationWithoutTouch, value, touched, warnings)=>{
    const hasWarnings = !!warnings && warnings.length > 0;
    if (!errorDisabled && validationWithoutTouch) return !!value && hasWarnings;
    return touched && hasWarnings;
};
const DateInput_DateInput = (t0)=>{
    var _meta_data, _meta_data1;
    const $ = c(83);
    let customCalendarDownload;
    let externalError;
    let label;
    let labelIcon;
    let name;
    let onClear;
    let otherSelectedDate;
    let recognizedValue;
    let renderDayFooter;
    let renderDayTooltip;
    let rest;
    let shouldDisableDate;
    let t1;
    let t10;
    let t11;
    let t12;
    let t13;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let tooltip;
    let validateArray;
    let warnings;
    if ($[0] !== t0) {
        ({ label, labelIcon, name, tooltip, onClear, placeholder: t1, required: t2, disablePast: t3, minDate: t4, maxDate: t5, recognizedValue, shouldDisableDate, externalError, otherSelectedDate, clearable: t6, disabled: t7, showRange: t8, alwaysShowClear: t9, loading: t10, isRecognitionUsedBefore: t11, testId, validateArray, warnings, renderDayTooltip, renderDayFooter, validationWithoutTouch: t12, validationWhenDisabled: t13, customCalendarDownload } = t0), rest = _object_without_properties(t0, [
            "label",
            "labelIcon",
            "name",
            "tooltip",
            "onClear",
            "placeholder",
            "required",
            "disablePast",
            "minDate",
            "maxDate",
            "recognizedValue",
            "shouldDisableDate",
            "externalError",
            "otherSelectedDate",
            "clearable",
            "disabled",
            "showRange",
            "alwaysShowClear",
            "loading",
            "isRecognitionUsedBefore",
            "testId",
            "validateArray",
            "warnings",
            "renderDayTooltip",
            "renderDayFooter",
            "validationWithoutTouch",
            "validationWhenDisabled",
            "customCalendarDownload"
        ]);
        $[0] = t0;
        $[1] = customCalendarDownload;
        $[2] = externalError;
        $[3] = label;
        $[4] = labelIcon;
        $[5] = name;
        $[6] = onClear;
        $[7] = otherSelectedDate;
        $[8] = recognizedValue;
        $[9] = renderDayFooter;
        $[10] = renderDayTooltip;
        $[11] = rest;
        $[12] = shouldDisableDate;
        $[13] = t1;
        $[14] = t10;
        $[15] = t11;
        $[16] = t12;
        $[17] = t13;
        $[18] = t2;
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
        $[26] = testId;
        $[27] = tooltip;
        $[28] = validateArray;
        $[29] = warnings;
    } else {
        customCalendarDownload = $[1];
        externalError = $[2];
        label = $[3];
        labelIcon = $[4];
        name = $[5];
        onClear = $[6];
        otherSelectedDate = $[7];
        recognizedValue = $[8];
        renderDayFooter = $[9];
        renderDayTooltip = $[10];
        rest = $[11];
        shouldDisableDate = $[12];
        t1 = $[13];
        t10 = $[14];
        t11 = $[15];
        t12 = $[16];
        t13 = $[17];
        t2 = $[18];
        t3 = $[19];
        t4 = $[20];
        t5 = $[21];
        t6 = $[22];
        t7 = $[23];
        t8 = $[24];
        t9 = $[25];
        testId = $[26];
        tooltip = $[27];
        validateArray = $[28];
        warnings = $[29];
    }
    const placeholder = void 0 === t1 ? "\u0414\u0414.\u041C\u041C.\u0413\u0413\u0413\u0413" : t1;
    const required = void 0 === t2 ? false : t2;
    const disablePast = void 0 === t3 ? false : t3;
    const minDate = void 0 === t4 ? CALENDAR_MIN_DATE : t4;
    const maxDate = void 0 === t5 ? CALENDAR_MAX_DATE : t5;
    const clearable = void 0 === t6 ? false : t6;
    const disabled = void 0 === t7 ? false : t7;
    const showRange = void 0 === t8 ? false : t8;
    const alwaysShowClear = void 0 === t9 ? false : t9;
    const loading = void 0 === t10 ? false : t10;
    const isRecognitionUsedBefore = void 0 === t11 ? false : t11;
    const validationWithoutTouch = void 0 === t12 ? false : t12;
    const validationWhenDisabled = void 0 === t13 ? false : t13;
    const { mutators } = useForm();
    const form = useForm();
    let t14;
    if ($[30] !== validateArray) {
        t14 = validateArray || [];
        $[30] = validateArray;
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] !== t14) {
        t15 = compose(t14);
        $[32] = t14;
        $[33] = t15;
    } else t15 = $[33];
    let t16;
    if ($[34] !== rest || $[35] !== t15) {
        t16 = _object_spread({
            validate: t15
        }, rest);
        $[34] = rest;
        $[35] = t15;
        $[36] = t16;
    } else t16 = $[36];
    const { input, meta } = useField(name, t16);
    let t17;
    if ($[37] !== warnings) {
        t17 = warnings || [];
        $[37] = warnings;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== t17) {
        t18 = composeWarnings(t17);
        $[39] = t17;
        $[40] = t18;
    } else t18 = $[40];
    const composedWarnings = t18;
    const errorDisabled = disabled || !validationWhenDisabled;
    let t19;
    if ($[41] !== errorDisabled || $[42] !== input.value || $[43] !== meta.error || $[44] !== meta.touched || $[45] !== validationWithoutTouch) {
        t19 = getIsRenderError(errorDisabled, validationWithoutTouch, input.value, meta.touched, meta.error);
        $[41] = errorDisabled;
        $[42] = input.value;
        $[43] = meta.error;
        $[44] = meta.touched;
        $[45] = validationWithoutTouch;
        $[46] = t19;
    } else t19 = $[46];
    const renderError = t19;
    const renderWarnings = getIsRenderWarnings(errorDisabled, validationWithoutTouch, input.value, meta.touched, null == (_meta_data = meta.data) ? void 0 : _meta_data.warnings);
    const t20 = renderError && meta.error;
    const t21 = renderWarnings ? null == (_meta_data1 = meta.data) ? void 0 : _meta_data1.warnings : void 0;
    let t22;
    if ($[47] !== alwaysShowClear || $[48] !== clearable || $[49] !== customCalendarDownload || $[50] !== disablePast || $[51] !== disabled || $[52] !== externalError || $[53] !== form.blur || $[54] !== input || $[55] !== isRecognitionUsedBefore || $[56] !== label || $[57] !== labelIcon || $[58] !== loading || $[59] !== maxDate || $[60] !== minDate || $[61] !== onClear || $[62] !== otherSelectedDate || $[63] !== placeholder || $[64] !== recognizedValue || $[65] !== renderDayFooter || $[66] !== renderDayTooltip || $[67] !== required || $[68] !== shouldDisableDate || $[69] !== showRange || $[70] !== t20 || $[71] !== t21 || $[72] !== testId || $[73] !== tooltip) {
        t22 = /*#__PURE__*/ jsx(DateInput, _object_spread_props(_object_spread({}, input), {
            testId: testId,
            formBlur: form.blur,
            label: label,
            labelIcon: labelIcon,
            tooltip: tooltip,
            onClear: onClear,
            disabled: disabled,
            placeholder: placeholder,
            error: t20,
            warnings: t21,
            minDate: minDate,
            maxDate: maxDate,
            recognizedValue: recognizedValue,
            isRecognitionUsedBefore: isRecognitionUsedBefore,
            required: required,
            disablePast: disablePast,
            otherSelectedDate: otherSelectedDate,
            externalError: externalError,
            shouldDisableDate: shouldDisableDate,
            clearable: clearable,
            showRange: showRange,
            alwaysShowClear: alwaysShowClear,
            loading: loading,
            renderDayTooltip: renderDayTooltip,
            renderDayFooter: renderDayFooter,
            customCalendarDownload: customCalendarDownload
        }));
        $[47] = alwaysShowClear;
        $[48] = clearable;
        $[49] = customCalendarDownload;
        $[50] = disablePast;
        $[51] = disabled;
        $[52] = externalError;
        $[53] = form.blur;
        $[54] = input;
        $[55] = isRecognitionUsedBefore;
        $[56] = label;
        $[57] = labelIcon;
        $[58] = loading;
        $[59] = maxDate;
        $[60] = minDate;
        $[61] = onClear;
        $[62] = otherSelectedDate;
        $[63] = placeholder;
        $[64] = recognizedValue;
        $[65] = renderDayFooter;
        $[66] = renderDayTooltip;
        $[67] = required;
        $[68] = shouldDisableDate;
        $[69] = showRange;
        $[70] = t20;
        $[71] = t21;
        $[72] = testId;
        $[73] = tooltip;
        $[74] = t22;
    } else t22 = $[74];
    let t23;
    if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = {
            values: true
        };
        $[75] = t23;
    } else t23 = $[75];
    let t24;
    if ($[76] !== composedWarnings || $[77] !== input.name || $[78] !== mutators) {
        t24 = /*#__PURE__*/ jsx(FormSpy, {
            subscription: t23,
            onChange: (t25)=>_async_to_generator(function*() {
                    const { values } = t25;
                    if (values) {
                        const warningsArray = yield composedWarnings(values[input.name], values);
                        mutators.setFieldData(input.name, {
                            warnings: warningsArray
                        });
                    }
                })()
        });
        $[76] = composedWarnings;
        $[77] = input.name;
        $[78] = mutators;
        $[79] = t24;
    } else t24 = $[79];
    let t25;
    if ($[80] !== t22 || $[81] !== t24) {
        t25 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t22,
                t24
            ]
        });
        $[80] = t22;
        $[81] = t24;
        $[82] = t25;
    } else t25 = $[82];
    return t25;
};
export { DateInput_DateInput as DateInput };
